import { React } from "react";
import { images } from "../../Shared";

import "../../css/thankyou.css";

function ThankYou() {
  return (
    <div>
      <div className="tr mt-90pxx">
        <img src={images.topBanner} width="100%" alt="Nfm Top Banner"/>
      </div>
      <div className="thank-you-page mt-120pxx container">
        <h1>Thank you for the purchase.</h1>
        <h2>Welcome to Nitro where everybody wins!</h2>
        <div>
          <p>
            Please  connect to the wallet used for making payment.
          </p>
          <p>
            Your NFM will be airdropped in the same wallet. You can check it in
            'My Collection'.
          </p>
          {/* <p>
            <a
              href="https://ecosystem.nitro.network/verifyEmail"
              className="purple-color-text"
            >
              Sign up
            </a>{" "}
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
